// extracted by mini-css-extract-plugin
module.exports = {"homeMarker":"Home_homeMarker__18LwH","featuresMarker":"Home_featuresMarker__37-cX","pricingMarker":"Home_pricingMarker__1sJWt","contactMarker":"Home_contactMarker__11ilx"};